import { isInNewCopyExperiment } from '@client/redux/experiments/selectors/new-copy';
import { useAppSelector } from '@client/redux/hooks';
import { useTrackStorefrontImpression } from '@hooks/useTrackStorefrontImpression';
import { Link } from '@tkww/orion-web-ds-action';
import { Icon } from '@tkww/orion-web-ds-graphic';
import { TextBody } from '@tkww/orion-web-ds-text';
import React, { memo } from 'react';
import { useTrackTrustLinkClick } from './hooks/useTrackTrustLinkClick';
import Styles from './styles.scss';

const TRUST_COPY_TEXT = `Your trust is our goal. Our community relies on honest reviews to help
				you make those big decisions with ease.`;
const TRUST_COPY_URL =
	'https://helpcenter.theknot.com/hc/en-us/articles/47988914841748-What-is-the-TKWW-Global-User-Reviews-Policy';

const VerifiedReviewsBox = memo(() => {
	const impressionRef = useTrackStorefrontImpression('Verified Reviews Box');
	const inNewCopyExperiment = useAppSelector(isInNewCopyExperiment);
	const trackTrustLinkClick = useTrackTrustLinkClick();

	return (
		<div
			className={Styles.verifiedReviewsBox}
			ref={impressionRef}
			data-testid="verified-reviews-box"
		>
			<Icon
				size="md"
				name="person-check"
				className={Styles.icon}
				aria-label="Verified reviews"
			/>
			<TextBody size="sm" className={Styles.text}>
				{inNewCopyExperiment ? (
					<>
						We believe in the full picture — we show every review that complies
						with our{' '}
						<Link
							styleType="secondary"
							href={TRUST_COPY_URL}
							target="_blank"
							rel="noopener noreferrer"
							onClick={trackTrustLinkClick}
						>
							reviews policy
						</Link>
						, regardless of rating.
					</>
				) : (
					TRUST_COPY_TEXT
				)}
			</TextBody>
		</div>
	);
});

export default VerifiedReviewsBox;
